import { useTranslation } from "react-i18next";
import React from "react";
import { deleteHomePageCategory } from "../../../../../../../axios/api/services";
import { toast } from "react-toastify";
import useAppDispatch from "../../../../../../../hooks/redux/base/useAppDispatch";
import { ConfirmDialog } from "@duosoftbg/nacid-components";
import useAppSelector from "../../../../../../../hooks/redux/base/useAppSelector";
import { homePageCategorySection } from "../../../../../../../utils/constants";
import { closeDeleteModal } from "../../../../../../../store/redux/slice/ComponentsControl/homePageCategoryControl";
import { addCategoryViewObject } from "../../HomePageCategoryManagement";

const DeleteCategoryDialog = () => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  const { open, id } = useAppSelector((state) => {
    return state.ComponentsControl.homePageCategoryControl.sections[homePageCategorySection.category].modals.delete;
  });

  const handleCloseDialog = () => {
    dispatch(closeDeleteModal({ section: homePageCategorySection.category }));
  };

  const onSuccess = (response) => {
    addCategoryViewObject(response, dispatch);
    handleCloseDialog();
    toast.success(t("m.save.data.success"));
  };

  return (
    <ConfirmDialog
      open={open}
      onClose={handleCloseDialog}
      promiseFunction={() => deleteHomePageCategory(id)}
      onSuccess={onSuccess}
      title={"t.homePage.category.delete.dialog"}
      message={"m.delete.homePage.category.warning.message"}
    />
  );
};

export default DeleteCategoryDialog;
